import {
  GET_DOSSIER_SUBJECTS_START,
  GET_DOSSIER_SUBJECTS_SUCCESS,
  GET_DOSSIER_SUBJECTS_ERROR,
  GET_CHECKUP_SUMMARY_START,
  GET_CHECKUP_SUMMARY_SUCCESS,
  GET_CHECKUP_SUMMARY_ERROR,
  GET_CRISIS_COMPANIES_START,
  GET_CRISIS_COMPANIES_SUCCESS,
  GET_CRISIS_COMPANIES_ERROR
} from "../actions/rating";

const defaultState = {
  companyRatingList: {
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    },
    list: []
  },
  isGettingRatingCompanies: false,
  companyCheckupSummary: {
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    },
    data: {}
  },
  crisisCompanies: {
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    },
    data: {}
  }
};

export default function rating(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case GET_DOSSIER_SUBJECTS_START:
    return {
      ...defaultS,
      companyRatingList: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      },
      isGettingRatingCompanies: true
    };
  case GET_DOSSIER_SUBJECTS_SUCCESS:
    return {
      ...defaultS,
      companyRatingList: {
        status: {
          started: false,
          error: false,
          ended: true
        },
        list: payload || []
      },
      isGettingRatingCompanies: false
    };
  case GET_DOSSIER_SUBJECTS_ERROR:
    return {
      ...defaultS,
      companyRatingList: {
        status: {
          started: false,
          error: true,
          ended: true
        },
        list: []
      },
      isGettingRatingCompanies: false
    };
  case GET_CHECKUP_SUMMARY_START:
    return {
      ...defaultS,
      companyCheckupSummary: {
        data: {},
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case GET_CHECKUP_SUMMARY_SUCCESS:
    return {
      ...defaultS,
      companyCheckupSummary: {
        data: payload,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };
  case GET_CHECKUP_SUMMARY_ERROR:
    return {
      ...defaultS,
      companyCheckupSummary: {
        data: {},
        status: {
          started: false,
          error: true,
          ended: false
        }
      }      
    };
  case GET_CRISIS_COMPANIES_START:
    return {
      ...defaultS,
      crisisCompanies: {
        data: {},
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case GET_CRISIS_COMPANIES_SUCCESS:
    return {
      ...defaultS,
      crisisCompanies: {
        data: payload,
        status: {
          started: false,
          error: false,
          ended: true
        }
      }
    };
  case GET_CRISIS_COMPANIES_ERROR:
    return {
      ...defaultS,
      crisisCompanies: {
        data: {},
        status: {
          started: false,
          error: true,
          ended: false
        }
      }
    };
  default:
    return defaultS;
  }
}
